import { defineMessages } from 'react-intl';

export default defineMessages({
  errorMessage: {
    id: 'frontbucket.jiraTab.assignees.errorMessage',
    description: 'Message displayed when it fails to load the assignees',
    defaultMessage: `We can't load the assignee list.`,
  },
  assigneesDropdownHeader: {
    id: 'frontbucket.jiraTab.assignees.dropdownHeader',
    description: 'Label for the assignees options group header.',
    defaultMessage: 'Assignees',
  },
  unassigned: {
    id: 'frontbucket.jiraTab.assignees.unassigned',
    description:
      'Label to filter for issues which are not assigned to any user.',
    defaultMessage: 'Unassigned',
  },
  filterAssignees: {
    id: 'frontbucket.jiraTab.assignees.filterAssignees',
    description:
      'Placeholder text for text field which allows user to filter assignees',
    defaultMessage: 'Filter assignees',
  },
  typeToRefineListFurther: {
    id: 'frontbucket.jiraTab.assignees.typeToRefineListFurther',
    description:
      'Text for a message telling users to enter a search term to see more results',
    defaultMessage: 'Type to refine list further',
  },
  noMatchingOptions: {
    id: 'frontbucket.jiraTab.assignees.noMatchingOptions',
    description:
      'Text for a message telling users that there are no results that match their search',
    defaultMessage: 'No matching options',
  },
  moreAssignees: {
    id: 'frontbucket.jiraTab.assignees.moreAssignees',
    description:
      'Message informing users how many search results have been hidden',
    defaultMessage: '{numAssignees} more assignees',
  },
});
